<ng-container *ngIf="!isLoading(); else loading">
  <glxy-empty-state
    class="scrape-in-progress"
    [size]="'small'"
    *ngIf="
      websiteScrapeConfig.scrapeProgress !== scrapeProgressStates.WEBSITE_SCRAPE_CONFIG_PROGRESS_DONE;
      else scrapedPages
    "
  >
    <glxy-empty-state-hero>
      <glxy-loading-spinner [size]="'small'"></glxy-loading-spinner>
    </glxy-empty-state-hero>
    <glxy-empty-state-title>
      {{ getScrapeProgressTitle() | translate }}
    </glxy-empty-state-title>
    <p>{{ 'EDIT_KNOWLEDGE.WEBSITE_SCRAPE_CONFIG.SCRAPE_IN_PROGRESS_CLARIFICATION' | translate }}</p>
  </glxy-empty-state>

  <ng-template #scrapedPages>
    <ng-container [formGroup]="form">
      <glxy-form-field formArrayName="scrapedPages">
        <glxy-label>{{ 'EDIT_KNOWLEDGE.WEBSITE_SCRAPE_CONFIG.SELECT_PAGES_TO_TRAIN' | translate }}</glxy-label>
        <p *ngIf="getScrapedPagesCount() > 1">
          <a (click)="selectAll()">{{
            'EDIT_KNOWLEDGE.WEBSITE_SCRAPE_CONFIG.SELECT_ALL' | translate: { scrapedPagesCount: getScrapedPagesCount() }
          }}</a>
        </p>
        <ng-container *ngFor="let pageControl of scrapedPagesArray.controls; let i = index">
          <mat-checkbox [formControl]="pageControl">
            {{ websiteScrapeConfig?.scrapedPages[i]?.title }}
            <extended>{{ websiteScrapeConfig?.scrapedPages[i]?.url }}</extended>
            <extended class="scraped-page-error" *ngIf="websiteScrapeConfig?.scrapedPages[i]?.errorMessage">{{
              websiteScrapeConfig?.scrapedPages[i]?.errorMessage
            }}</extended>
          </mat-checkbox>
        </ng-container>
      </glxy-form-field>
    </ng-container>
  </ng-template>
</ng-container>

<ng-template #loading>
  <glxy-loading-spinner></glxy-loading-spinner>
</ng-template>
